/**
 * Created by natalia.petrov on 4/4/2017.
 */
import styled from 'styled-components';
import {Link} from 'react-router-dom';

const StyledShowAllLink = styled(Link)`
		color: ${props => props.theme.brandColor};
		&:hover{
		   color: ${props => props.theme.brandColor};
		}
`;
export default StyledShowAllLink;



// WEBPACK FOOTER //
// ./components/utils/Styled/links.js